<div class="flex-row px-1">
  <div class="flex-row justify-start items-center hide-lt-lg show-gt-md">
    @if (showAuctionTypeFilter) {
      <app-auction-type-filter #auctionTypeFilter (onAuctionTypeSelectionChange)="auctionTypeSelectionChanged($event)"></app-auction-type-filter>
    }
    <app-property-type-filter #propertyTypeFilter (onPropertyTypeSelectionChange)="propertyTypeSelectionChanged($event)"></app-property-type-filter>
    <app-state-filter #stateFilter (onStateSelectionChange)="stateSelectionChanged($event)"></app-state-filter>
    <app-sale-type-filter #saleTypeFilter (onSaleTypeSelectionChange)="saleTypeSelectionChanged($event)"></app-sale-type-filter>
    <app-property-features-filter #propertyFeaturesFilter (onPropertyFeaturesSelectionChange)="propertyFeaturesSelectionChanged($event)"></app-property-features-filter>
    @if (anyFilterSet) {
      <a mat-button class="clear-filter warn-color" (click)="onClearFiltersClick()">Clear Filters</a>
    }
  </div>
  <div class="flex-row justify-start items-center show-lt-lg hide-gt-md">
    <a mat-button class="primary-menu-button all-filters" (click)="onAllFiltersClick()">
      All Filters
      @if (anyFilterSet) {
        <span>({{ filterLength }})</span>
      }
    </a>
  </div>
  <div class="flex-row justify-end items-center">
    <button mat-button class="showMap-btn" (click)="toggleViewType()" color="primary">
      @if (viewType == 'grid') {
        <span>SHOW MAP</span>
      }
      @if (viewType == 'map' || viewType == 'mapOnly') {
        <span>HIDE MAP</span>
      }
      <mat-icon>map</mat-icon>
    </button>
  </div>
</div>
